import { render } from "./ExtranetForgotPassword.vue?vue&type=template&id=de75c810&scoped=true"
import script from "./ExtranetForgotPassword.vue?vue&type=script&lang=js"
export * from "./ExtranetForgotPassword.vue?vue&type=script&lang=js"

import "./ExtranetForgotPassword.vue?vue&type=style&index=0&id=de75c810&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de75c810"]])

export default __exports__